<template>
	<div id="footerComponent" >
		Copyright 
	</div>
</template>

<script>
	// import { json } from '@/common/common.js'
	export default {
		name: 'myFooter',
		data() {
			return {
			}
		},
		components: {
		},
		computed: {},
		methods: {},
		mounted() {
			let _this = this

		}
	}
</script>

<style scoped lang="scss">
	#footerComponent {
		height: 1.25rem; line-height: 1.25rem; text-align: center;
		color:#333;
	}
</style>



// WEBPACK FOOTER //
// src/components/footerComponent.vue